import Branch from "@/entity/Branch";
import ResponseGroup from "@/entity/ResponseGroup";
import Survey from "@/entity/Survey";
import store from "@/store";
import ItemType from "@/entity/ItemType";
import Response from "@/entity/Response";
import Mapping from "@/entity/Mapping";
import {helper} from "@/services/Helper";
import Item from "@/entity/Item";
import {createItemFromType, getAlias, getIdentifier} from "@/services/ItemFunction";

class Mapper {
    rg!: ResponseGroup;
    survey!: Survey;
    surveys = {};
    surveyByItemTypes = {};
    responseGroups: ResponseGroup[] = [];
    branch!: Branch;
    items: any = {};
    assetUuids = []
    itemTypes: any = {}

    assetCount = 0
    attestations = {
        green: 0,
        blue: 0,
        yellow: 0
    }
    workflow: any = null
    workflows: string[] = []

    categories: string[] = []
    required: number[] = []
    itemID = 1

    private toArray(v: any): any[] {
        if (!v) return [];
        if (Array.isArray(v)) return v;
        return Object.values(v);
    }

    map(rg: ResponseGroup, itemTypes = null) {
        this.attestations = {
            green: 0,
            blue: 0,
            yellow: 0
        }
        this.items = {};
        this.categories = []
        this.assetUuids = []
        this.required = []
        this.workflows = []
        this.itemID = 0
        this.branch = store.state.mainStore.currentBranch;
        this.responseGroups = Object.values(store.state.mainStore.rgs || {});
        if (itemTypes) {
            this.itemTypes = itemTypes
        } else if (this.branch && this.branch.items) {
            this.toArray(this.branch.items).forEach((i: ItemType) => {
                let model: any = JSON.parse(JSON.stringify(i))
                model.properties = {}
                this.toArray(i.properties).forEach((prop: any) => {
                    model.properties[prop.code] = prop
                })
                this.itemTypes[i.code] = model;
            });
        }


        store.state.mainStore.surveys.forEach((s: any) => {
            if (s.uuid) this.surveys[s.uuid] = s;
            if (s.slug) this.surveys[s.slug] = s;
            if (s.item) this.surveyByItemTypes[s.item] = s.uuid || s.slug;
        })
        this.assets = []
        const surveyKey = rg.survey?.uuid || rg.survey?.slug || rg.surveySlug;
        const currentSurvey = this.surveys[surveyKey];
        if (!currentSurvey) {
            return { required: [], items: {}, itemUuid: null, assetUuids: [], workflows: [], itemTypes: this.itemTypes };
        }
        rg.survey = currentSurvey;
        let currentItem: any = null;
        Object.values(this.itemTypes).forEach((i: any) => {
            if (i.required || i.isRoot || i.uuid === currentSurvey.item) {
                const item: any = this.createCompactItem(i);
                this.required.push(this.itemID)
                if (i.uuid === currentSurvey.item) {
                    currentItem = this.itemID;
                }
            }
        })
        this.mapRg(rg);
        this.handleWorkflows()
        return {required: this.required, items: this.items, itemUuid: currentItem, 'assetUuids': this.assetUuids, workflows: this.workflows, itemTypes: this.itemTypes, categories: this.categories};
    }

    assets: Item[] = []

    handleWorkflows() {
        this.assetUuids.forEach((uuid: any) => {
            const item = this.items[uuid]
            if (!item || !this.itemTypes[item.modelCode]) return;
            const workflows = this.itemTypes[item.modelCode].workflows
            if (workflows && Array.isArray(workflows) && !helper.empty(workflows)) {
                workflows.forEach((workflow) => {
                    const code = workflow.code.toLowerCase()
                    if(!this.workflows.includes(code)){
                        this.workflows.push(code)
                    }
                    if (code === 'asaci') {
                        this.asaciWorkflow(item, workflow)
                    }
                })
            }
        })
    }

    asaciWorkflow(item: any, workflow: any) {
        const itemModel = this.itemTypes[item.modelCode]
        for (const rule of workflow.rules) {
            const allMatch = rule.conditions.every(cond => {
                let res = true;
                if (!helper.empty(cond.value) && !helper.empty(cond.property)) {
                    const pModel: any = Object.values(itemModel.properties).find((p: any) => {
                        return p.uuid === cond.property || p.code === cond.property
                    })
                    const value = item.properties[pModel.code];
                    res = Function('"use strict"; return (' + JSON.stringify(value) + cond.operator + JSON.stringify(cond.value) + ')')();
                }
                return res;
            });
            if (allMatch) {
                if (this.attestations.hasOwnProperty(rule.result)) {
                    this.attestations[rule.result]++
                } else {
                    console.log('propriété ' + rule.result + ' introuvable dans attestations')
                }
                return rule.result;
            }
        }
    }

    public function

    createCompactItem(type: ItemType, parentItem = null, parentProperty = null) {
        // const uuid = helper.generateId()
        this.itemID++
        const uuid = this.itemID
        const item: any = {
            // uuid: uuid,
            modelCode: type.code,
            name: type.name,
            // parentItem: parentItem,
            properties: {},
        }
        Object.values(type.properties).forEach((p: any) => {
            item.properties[p.code] = null
        })
        if (type.className === 'Asset') {
            this.assetUuids.push(uuid)
        }
        this.items[uuid] = item;
        return item;
    }

    public createItemFromType(itemType: ItemType) {
        return this.createCompactItem(itemType)
    }

    getAlias() {

    }

    getIdentifier() {

    }

    mapRg(rg: ResponseGroup) {
        this.required.forEach((uuid: any) => {
            this.mapItem(uuid, rg, rg.survey.uuid)
        })
    }

    mapItem(uuid: any, rg: ResponseGroup, surveyUuid: string, parentMappings: any[] = [], parentRgs: any[] = []) {
        const item = this.items[uuid]
        const survey = this.surveys[surveyUuid]
        // Les sous-RG sont lazy-loades (stubs sans responses). On saute le mapping
        // tant qu'ils ne sont pas hydrates pour eviter un crash sur rg.responses.find.
        if (!rg || !Array.isArray(rg.responses) || !survey) return;
        this.toArray(survey.mappings).forEach((m: Mapping) => {
            const index = parentMappings.findIndex((exist: Mapping) => {
                return exist.id === m.id
            })
            if (index === -1) {
                parentMappings.push(m)
            }
        })

        // console.log('-----------------------------')
        // console.log('mapping item ' + item.name + ' model ' + item.modelCode)
        // item.responseGroup = rg.uuid
        parentRgs.push(rg)
        const itemTypeModel = this.itemTypes[item.modelCode];
        if (!itemTypeModel || !itemTypeModel.properties) return;
        Object.keys(item.properties).forEach((p) => {
            const pModel: any = Object.values(itemTypeModel.properties).find((model: any) => {
                return model.code === p
            })
            if (!pModel) return;
            const mappings = parentMappings.filter((m: Mapping) => {
                return m.propertyUuid === pModel.uuid;
            });
            mappings.sort((a: Mapping, b: Mapping) => {
                if (a.ranking && b.ranking) {
                    return a.ranking - b.ranking;
                }
                return 1
            })
            // Parmi les mappings triés par ranking, prendre la première question visible avec une réponse
            let mapped = false;
            for (const m of mappings) {
                if (mapped) break;
                const mQuestionId = m.questionUuid || m.question?.id || (m as any).question;
                const response = rg.responses.find((r: Response) => {
                    return r.questionUuid === mQuestionId
                        || r.question?.uuid === mQuestionId
                        || r.question?.id == mQuestionId
                        || String(r.question?.id) === String(mQuestionId);
                });
                if (!response) continue;
                // Résoudre la question : soit via response.question (legacy), soit en la cherchant
                // dans le survey via les IDs/UUIDs du mapping. Sans ça, les entries du nouveau
                // FormStore (qui n'ont pas response.question hydraté) bypassent la check de
                // visibilité et envoient au moteur des valeurs de questions masquées.
                let question: any = response.question || null;
                if (!question && survey && typeof survey.getQuestions === 'function') {
                    const questions = survey.getQuestions();
                    question = questions.find((q: any) =>
                        q.uuid === mQuestionId
                        || String(q.id) === String(mQuestionId)
                        || q.uuid === response.questionUuid
                        || String(q.id) === String((response as any).questionId)
                    ) || null;
                }
                if (question && typeof question.isVisibleIn === 'function' && !question.isVisibleIn(survey, rg)) {
                    continue;
                }
                if (!helper.empty(response.value)) {
                    item.properties[p] = response.value;
                    mapped = true;
                }
            }

            if (pModel.type.code.match(/OBJECT|OBJECT_GROUP/)) {
                // console.log('mapping object group ' + pModel.name)
                item.properties[p] = [];

                const itemType: any = this.toArray(this.branch.items).find((i: ItemType) => {
                    return i.uuid === pModel.value;
                });
                const subSurvey = this.surveys?.[this.surveyByItemTypes?.[itemType?.uuid]] ?? null
                if (subSurvey) {
                    const m: Mapping = parentMappings.find((m: Mapping) => {
                        return m.propertyUuid === pModel.uuid;
                    }) as any;
                    let response = null;
                    if (m) {
                        const mqId = m.questionUuid || m.question?.id || (m as any).question;
                        response = rg.responses.find((r: Response) => {
                            return r.questionUuid === mqId
                                || r.question?.uuid === mqId
                                || r.question?.id == mqId
                                || String(r.question?.id) === String(mqId);
                        });
                    }
                    // let subItem = this.createItemFromType(itemType);
                    if (response) {
                        response.responseGroups.forEach((subRg: ResponseGroup) => {
                            const subItem = this.createCompactItem(itemType,uuid,item.properties[p].uuid);
                            const subId = this.itemID
                            this.mapItem(subId, subRg, subSurvey.uuid, parentMappings, parentRgs);
                        });
                    } else {
                        const subItem = this.createCompactItem(itemType,uuid,item.properties[p].uuid);
                        const subId = this.itemID
                        this.mapItem(subId, rg, subSurvey.uuid, parentMappings, parentRgs);
                        item.properties[p].push(subId);
                    }
                } else {
                    let subItem = this.createCompactItem(itemType,uuid,item.properties[p].uuid);
                    const subId = this.itemID
                    this.mapItem(subId, rg, survey.uuid);
                    item.properties[p].push(subId);
                }
            }
            if (item.modelCode.toLowerCase() === "avenant" && pModel.code === "source") {
                item.properties[p] = rg.source;
            }


            // if ($propertyModel['type']['code'] === 'PACK') {
            //     $value = json_decode($response->getValue(), true);
            //     if (isset($value['pack']['id']) && isset($value['pack']['code'])) {
            //         $p['value'] = ['id' => $value['pack']['id'], 'code' => $value['pack']['code']];
            //     }
            // }
            //
            // if ($propertyModel['type']['code'] === 'GUARANTEE_ARRAY') {
            //     $value = json_decode($response->getValue(), true);
            //     $p['value'] = [];
            //
            //     if (isset($value['risks'])) {
            //         $p['value'] = $value['risks'];
            //     }
            //     if (isset($value['optionals'])) {
            //         $p['value'] = array_merge($p['value'],$value['optionals']);
            //     }
            // }

            if (pModel.type.code === 'PACK' && !helper.empty(item.properties[p])) {
                try {
                    const value = JSON.parse(item.properties[p]);
                    if (value?.pack?.code) {
                        item.properties[p] = value.pack.code
                    }
                } catch (e) {
                }
            }
            if (pModel.type.code === 'GUARANTEE_ARRAY' && !helper.empty(item.properties[p])) {
                try {
                    const value = JSON.parse(item.properties[p]);
                    if (value?.risks) {
                        item.properties[p] = value.risks
                    }
                } catch (e) {

                }
            }

            if (pModel.type.code === 'PACK_CATEGORY' && !helper.empty(item.properties[p])) {
                try {
                    const value = JSON.parse(item.properties[p]);
                    if (value?.category?.slug) {
                        item.properties[p] = value.category.slug?.replace(/_/g, "-").toUpperCase()
                        this.categories.push( item.properties[p])
                    }
                } catch (e) {
                    if (!helper.empty(item.properties[p])) {
                        this.categories.push(item.properties[p]?.replace(/_/g, "-").toUpperCase())
                    }
                }
            }
            if (helper.empty(item.properties[p]) && !helper.empty(pModel.value)) {
                item.properties[p] = pModel.value
            }


        })

        // console.log('*****************************')
        return item;
    }
}

export const mapper = new Mapper();
